<p-table styleClass="p-datatable-sm p-datatable-striped sticky-header p-inner-table-auto head-top"
         dataKey="Id"
         stateStorage="local"
         [selectionMode]="selectionMode"
         [metaKeySelection]="false"
         [value]="filteredData$ | async"
         [lazy]="true"
         [lazyLoadOnInit]="true"
         [paginator]="true"
         [sortField]="tableSortField"
         [sortOrder]="tableSortOrder"
         [rows]="filter.Page.Size"
         [rowsPerPageOptions]="rowsPerPageOptions"
         [first]="filter.Page.Number * filter.Page.Size"
         [showCurrentPageReport]="true"
         [totalRecords]="filter.Page.Total"
         [stateKey]="stateKey"
         [stateStorage]="appConfig.primeNgStateStorage"
         [filters]="tableFilters"
         (onLazyLoad)="onLazyLoad($event)"
         (onStateRestore)="onStateRestore($event)"
         [(selection)]="selectedResource"
         (onRowSelect)="onRowSelect()"
         currentPageReportTemplate="{first} to {last} of {totalRecords}">
  <ng-template pTemplate="header">
    <ng-container *transloco="let t; read: 'ime.manufacturing.resources'">
    <tr class="sticky-top-2">
      <th style="width: 1rem" *ngIf="selectionMode == 'multiple'">
        <p-tableHeaderCheckbox (click)="onRowSelect()"></p-tableHeaderCheckbox>
      </th>
      <th pSortableColumn="Code">
        {{t('Code')}}
        <p-sortIcon field="Code"></p-sortIcon>
      </th>
      <th pSortableColumn="Name">
        {{t('Name')}}
        <p-sortIcon field="Name"></p-sortIcon>
      </th>
      <th pSortableColumn="KindClv">
        {{t('Kind')}}
        <p-sortIcon field="KindClv"></p-sortIcon>
      </th>
      <th pSortableColumn="PricePerHourTotal">
        {{t('PricePerHour')}}
        <p-sortIcon field="PricePerHourTotal"></p-sortIcon>
      </th>
      <th>
        {{t('From Resource Connections')}}
      </th>
      <th>
        {{t('To Resource Connections')}}
      </th>
      <th class="min-wx-96" *ngFor="let spec of filter.Data.SelectedSpecs">
        <ng-container *ngIf="(propertiesQuery.selectEntity(spec) | async) as property">
          <div class="p-d-flex p-jc-between p-ai-center h5">
            {{property | displayName}}
          </div>
        </ng-container>
      </th>
      <th class="wx-48">
        <div class="dropdown" #menu="ngbDropdown" ngbDropdown [autoClose]="'outside'" [placement]="['bottom-right', 'bottom-left']" (openChange)="onTableDropdownOpen($event)">
          <button type="button" class="p-column-filter-menu-button p-link dropdown-toggle-without-arrow" [class.p-column-filter-menu-button-active]="hasFilters" ngbDropdownToggle role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="pi pi-filter-icon pi-filter"></span>
          </button>
          <div ngbDropdownMenu>
            <button class="dropdown-item" (click)="clearState(); menu.close();">{{t('Clear Sort/Filter')}}</button>
            <app-saved-filter-menu-item [savedFilterPropertyId]="resourceListPropertyId" [stateKey]="stateKey" (selected)="loadSavedState($event)"></app-saved-filter-menu-item>
            <div class="dropdown-divider"></div>
            <app-spec-search-menu-item [relevantSpecs]="allSpecs" [tableDropdownClosed]="tableDropdownClosed" [filterData]="filter.Data" (selectionChange)="toggleSpecSelection($event, filter)" (showOnlyRelevantSpecsChange)="tryLazyLoad()"></app-spec-search-menu-item>
          </div>
        </div>
      </th>
    </tr>
    <tr *ngIf="filter.AdvancedFilter">
      <th [colSpan]="2"></th>
      <th class="d-flex">
        <app-column-filter-field-constraints-view class="col" [filter]="kindFilter">
          <ng-template #valueTemplate let-value="value">
            {{(classificatorValueService.selectEntity(value) | async)?.DisplayName}}
          </ng-template>
        </app-column-filter-field-constraints-view>
        <p-columnFilter matchMode="equals" display="menu" field="KindClv" [matchModeOptions]="choiceMatchModeOptions" [showAddButton]="true" [showOperator]="true" [maxConstraints]="10" #kindFilter>
          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
            <ng-select class="select-sm form-control dropdown-auto-width" [selectOnTab]="true" [appendTo]="null" name="itemGroupFilter"
                       [items]="classificatorValueService.resourceKinds$ | async" bindValue="Id" bindLabel="DisplayName"
                       [ngModel]="value" (ngModelChange)="filter($event)">
            </ng-select>
          </ng-template>
        </p-columnFilter>
      </th>
      <th [colSpan]="3"></th>
      <th *ngFor="let spec of filter.Data.SelectedSpecs" app-spec-column-filter [allSpecs]="allSpecs" [spec]="spec" class="min-wx-96"></th>
      <th></th>
    </tr>
    </ng-container>
  </ng-template>
  <ng-template pTemplate="body" let-row let-rowIndex>
    <ng-container *transloco="let t; read: 'ime.manufacturing.resources'">
    <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex">
      <td class="text-wrap text-break" [colSpan]="selectionMode == 'multiple' ? 2: 1">
        {{row.Code}}
      </td>
      <td class="text-wrap text-break">
        {{row.Name}}
      </td>
      <td>
        {{(classificatorValueService.selectEntity(row.KindClv) | async)?.DisplayName}}
      </td>
      <td>
        <ng-container [ngTemplateOutlet]="pricePerHour" [ngTemplateOutletContext]="{row: row}"></ng-container>
      </td>
      <td class="text-wrap text-break">
        <ng-container [ngTemplateOutlet]="connection" [ngTemplateOutletContext]="{row: row, connections: row.FromResourceConnections}"></ng-container>
      </td>
      <td class="text-wrap text-break">
        <ng-container [ngTemplateOutlet]="connection" [ngTemplateOutletContext]="{row: row, connections: row.ToResourceConnections}"></ng-container>
      </td>
      <td *ngFor="let spec of filter.Data.SelectedSpecs">
        <ng-container *ngIf="row.Specs[spec]">{{row.Specs[spec][0]?.Value}}</ng-container>
        <div *ngFor="let groupByValue of row.Specs[spec] | tail: 1 | groupByValues: 'Value'">
              <span class="fw-light fst-italic" *ngFor="let line of groupByValue; let last = last">
                {{(languagesQuery.selectEntity(line.Key) | async)?.Code}}{{last ? ':' : ', '}}
              </span>
          {{groupByValue[0]?.Value}}
        </div>
      </td>
      <td [width]="50">
        <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="open(row)">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
        </button>
      </td>
    </tr>
    </ng-container>
  </ng-template>
  <ng-template #connection let-connections="connections">
    <ng-container *ngFor="let connection of connections?.slice(0, 10)">
      <a class="badge bg-primary me-1 px-1 text-wrap text-break text-start text-white text-decoration-none" [routerLink]="['edit', connection]">
        {{(resourcesQuery.selectEntity(connection) | async)?.Code}}
      </a>
    </ng-container>
    <span *ngIf="connections?.length > 10" class="badge bg-gray-300 me-1 px-1 text-light">...</span>
  </ng-template>
  <ng-template #pricePerHour let-row="row">
    <ng-container *ngIf="row.HasPriceComponents">{{row.PricePerHourFormula}}</ng-container>
  </ng-template>
</p-table>
